import { render, staticRenderFns } from "./BankCharges.vue?vue&type=template&id=1bd84802&scoped=true"
import script from "./BankCharges.vue?vue&type=script&lang=js"
export * from "./BankCharges.vue?vue&type=script&lang=js"
import style0 from "./BankCharges.vue?vue&type=style&index=0&id=1bd84802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd84802",
  null
  
)

export default component.exports